import React, { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

const Wrapper = styled.div`
  margin: -1rem;
  padding: 1rem;
`;

export const TooltipContentWrapperStoppingPropagation: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <Wrapper
      onClick={e => {
        e.stopPropagation();
      }}
    >
      {children}
    </Wrapper>
  );
};
